import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { constObj } from '../../common/Constants/constants';
import { HttpcallService } from '../../common/services/httpcall.service';
import { SessionService } from '../../common/services/Session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-management',
  templateUrl: './access-management.component.html',
  styleUrls: ['./access-management.component.css']
})
export class AccessManagementComponent implements OnInit {
  public displayedColumns = ['FirstName', 'LastName', 'Email', 'Admin', 'Action'];
  public dataSource = new MatTableDataSource<User>();
  res: User[];

  pagesize: any = 10;
  actualresult: any;
  pagelistarray: number[] = [];
  accessmanagementHeader: any;
  firstNameCol: any;
  lastNameCol: any;
  emailCol: any;
  passwordCol: any;
  adminCol: any;
  actionCol: any;
  userList: any = [];
  noRecords = constObj.Norecords;

  outcome: boolean = false;
  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(private graphqlService: GraphqlService, private httpCallService: HttpcallService, private session: SessionService, private route: Router,
    public commonDataService: CommonDataService, private loginService: LoginService, private clipboard: Clipboard, private graphQlService: GraphqlService, public dialog: MatDialog) { }
  adminEmail: string = "";
  ngOnInit() {
    this.sortingColumn = "Email";
    //if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
    //  this.loginService.getSession().subscribe(data => {
    //    this.getAllUsers();
    //    this.session.assignSession(data);
    //  })
    //}
    //else {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        if (data != "") {
          this.adminEmail = data.user.email;
        }
      })
    }
    else {
      this.adminEmail = this.session.userInfo.user.email;
    }
    if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          this.mapAccessManagementLabel(data);
          this.session.assignglobalinfo(data);
          this.commonDataService.showLoader.next(false);
          this.outcome = true;
        }
      });
    }
    else {
      this.mapAccessManagementLabel(this.session.globallablesinfo);
      this.commonDataService.showLoader.next(false);
      this.outcome = true;
    }
    this.getAllUsers();
    //}
    this.commonDataService.userAddedUpdated.subscribe(data => {
      if (data != null && data) {
        this.commonDataService.showLoader.next(true);
        this.getAllUsers();
      }
    })
  }

  getAllUsers() {

    this.httpCallService.getAllUsers().subscribe((users) => { this.mapUsersData(users); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.microserviceFailureOnAccessManagement
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });
  }

  mapAccessManagementLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.accessmanagementHeader = labels.filter(x => x.key == "accessmanagement_header").map(y => y.value);
      this.firstNameCol = labels.filter(x => x.key == "accessmanagement_firstname").map(y => y.value);
      this.lastNameCol = labels.filter(x => x.key == "accessmanagement_lastname").map(y => y.value);
      this.emailCol = labels.filter(x => x.key == "accessmanagement_email").map(y => y.value);
      this.adminCol = labels.filter(x => x.key == "accessmanagement_isAdmin").map(y => y.value);
      this.actionCol = labels.filter(x => x.key == "accessmanagement_action").map(y => y.value);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortData = this.sortData();
  }

  sortingColumn: string = "";
  sortingDirection: any = 'asc';
  customSort(event) {
    this.sortingColumn = event.active;
    this.sortingDirection = event.direction;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortData = this.sortData();
  }

  sortData() {
    let sortFunction =
      (items: any[], ms: MatSort) => {
        if (!ms.active || ms.direction === '') {
          return items;
        }
        return items.sort((a: any, b: any) => {
          return this.sortProcess(a, b, ms.direction);
        });
      };
    return sortFunction;
  }

  sortProcess(a: any, b: any, direction) {
    let comparatorResult = 0;
    if (this.sortingColumn == "FirstName") {
      comparatorResult = a.FirstName.toLowerCase() > b.FirstName.toLowerCase() ? 1 : -1;
    }
    else if (this.sortingColumn == "LastName") {
      comparatorResult = a.LastName.toLowerCase().replace("(", "").replace(")", "") > b.LastName.toLowerCase().replace("(", "").replace(")", "") ? 1 : -1;
    }
    else if (this.sortingColumn == "Email") {
      comparatorResult = a.Email.toLowerCase() > b.Email.toLowerCase() ? 1 : -1;
    }
    return comparatorResult * (direction == 'asc' ? 1 : -1);
  }


  filter: any;
  onChangeText() {
    this.actualresult = this.userList.filter(x => x.email.toLowerCase().startsWith(this.filter.toLowerCase()));
    let ress = this.actualresult.map(x => ({ Id: x.id, FirstName: x.firstname, LastName: x.lastname, Email: x.email, Admin: x.isAdmin }))
    for (let i = 5; i <= 20; i = i + 5) {
      this.pagelistarray.push(i);
    }
    this.dataSource.data = ress as unknown as User[];
    this.commonDataService.showLoader.next(false);
  }

  redirectToDelete(id: string) {
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.userDeletionConfirmationPromptMessage
    });
    let user = this.actualresult.filter(x => x.id == id)[0];
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonDataService.isConfirmationPopUpOpen.next(false);
        this.commonDataService.showLoader.next(true);
        var deleteUser: User = {
          Id: user.id, FirstName: user.firstname, LastName: user.lastname, Email: user.email,
          Password: null, IsAdmin: user.admin, IsActive: false, CreatedBy: "", ModifiedBy: this.adminEmail
        }
        this.httpCall(deleteUser);
      }
    });
  }
  mapUsersData(resp) {
    this.userList = resp;
    this.actualresult = resp;
    let ress = this.actualresult.map(x => ({ Id: x.id, FirstName: x.firstname, LastName: x.lastname, Email: x.email, Admin: x.isAdmin }))
    for (let i = 5; i <= 20; i = i + 5) {
      this.pagelistarray.push(i);
    }
    this.dataSource.data = ress as unknown as User[];
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortData = this.sortData();
    this.commonDataService.showLoader.next(false);
  }

  httpCall(user: User) {
    this.httpCallService.addUpdateUser(user).toPromise()
      .then(response => {
        if (response.includes("rows affected.")) {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.userRemovedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.removeUserFromArray(user);
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.userRemovedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          //this.removeAnnotationFromArray(annotation);
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }
  removeUserFromArray(user: User) {
    this.userList = this.userList.filter(x => x.id != user.Id);
    var ress = this.userList.map(x => ({ Id: x.id, FirstName: x.firstname, LastName: x.lastname, Email: x.email, Admin: x.isAdmin }));
    for (let i = 5; i <= 20; i = i + 5) {
      this.pagelistarray.push(i);
    }
    this.dataSource.data = ress as unknown as User[];
    this.commonDataService.showLoader.next(false);
  }

  editUser(id: string) {
    let user = this.userList.filter(x => x.id == id);
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.userData.next(user[0]);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.rightOverlayOption.next("addUpdateUser");
  }

  AddUser() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.userData.next(null);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.rightOverlayOption.next("addUpdateUser");
  }

}

export interface User {
  Id: string
  FirstName: string;
  LastName: string;
  Email: string;
  Password: string;
  IsAdmin: boolean;
  IsActive: boolean;
  CreatedBy: string;
  ModifiedBy: string
}
